import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setBulkStateAmount, setLoadingState, setPaymentDrawerModal, setReferenceList } from "./BulkStateFilingSlice";
import { addNotifications } from "../../../../toaster/ToasterPortalSlice";
import { PAGE_STATE } from "../../../../constants/constants";
import ManageFormsService from "../../../../../../services/ManageFormsService";
import General from "../../../../../../libs/utility/General";

export const { getBulkStateFiling, getBulkReferences } = {
    getBulkStateFiling: (payload) => {
        return {
            type: "BULK_STATE_FILING/GET_BULK_STATE_AMOUNT",
            payload
        }
    },

    getBulkReferences: (payload) => {
        return {
            type: "BULK_STATE_FILING/GET_BULK_REFERENCES",
            payload
        }
    },
}

function* getBulkStateFilingAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading" }));
        const {referenceList, FormName} = action.payload;

        const jsonPreferences = referenceList.map(record => {
            return {
				key: "true",
				value: record?.FormIDs,
			};
        })

        const response = yield ManageFormsService.getBulkStateAmount({jsonPreferences, FormName});

        const { Data, Status, Message } = response?.data;
        if (Status && Data) {
            yield put(setBulkStateAmount({
                "OnlySeparateStatefiling": "false",
                "TotalFilingFee": Data,
                "FilingFee": "0",
                "USPSFee": "0",
                "TINMatchFee": "0",
                "StateFee": Data,
                "TINCount": "0",
                "StateFilingCount": "0",
                "USPSCount": "0",
                "FormCount": "0",
                "EstimatedTax": "0",
            }));
            yield put(setPaymentDrawerModal(true))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch the amount details", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the amount details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* getBulkReferencesAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING, message: "Loading" }));

        const { payerId, taxYear, formName } = action?.payload;
        const params = {
            payerId,
            taxYear,
            formName,
        }

        const response = yield ManageFormsService.getBulkReferences(params);

        const { Data, Status, Message } = response?.data;

        if (Status) {
            if(Data.length > 0 ){
                General.addOptionAndValueKeys(Data, "ReferenceID", "ReferenceID")
            }
            yield put(setReferenceList(Data || []))
        } else {
            yield put(setReferenceList([]))
            yield put(addNotifications({ heading: "Failed to fetch the reference details", message: Message }));
        }


    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch the reference details", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getBulkStateFiling().type, getBulkStateFilingAsync),
        takeLatest(getBulkReferences().type, getBulkReferencesAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);